import { motion } from 'framer-motion';
import ReactCountryFlag from 'react-country-flag';
import { sectionAnimVariants } from '../../../constants/animationVariants';
import { useCountryContext } from '../../../contexts/CountryProvider';
import useCheckUserFeaturePermissions from '../../../hooks/useCheckUserFeaturePermissions';
import AcademiaNotFound from '../../CommonComps/AcademiaNotFound';
import SetupCard from '../../CommonComps/Cards/SetupCard';
import SetupCardBodyInfo from '../../CommonComps/Cards/SetupCardBodyInfo';
import AcademiaLoading from '../../CommonComps/Loadings/AcademiaLoading';
import NoTableDataFound from '../../CommonComps/NoTableDataFound';
import PageHeader from '../../CommonComps/Titles/PageHeader';
import AddCountryAction from './AddCountryAction';
import FilterCountryDiv from './FilterCountryDiv';

const ShowAllCountries = () => {
  // integration of context hooks here
  const {
    setTargetedCountry,
    countryList,
    setShowDeleteModal,
    setShowEditModal,
    isError,
    isLoading,
    isSuccess,
  } = useCountryContext();

  // integration of custom hooks here
  const { featureBasedPermissions } = useCheckUserFeaturePermissions('country');

  // rendering show all countries component here
  return (
    <section>
      {isLoading ? (
        <AcademiaLoading />
      ) : isSuccess ? (
        featureBasedPermissions?.includes('READ') ? (
          <>
            <PageHeader
              headerText='All Countries'
              additionalComponent={
                <AddCountryAction
                  hasCreatePermission={featureBasedPermissions.includes(
                    'CREATE'
                  )}
                />
              }
            />

            <motion.div
              variants={sectionAnimVariants}
              initial='initial'
              animate='animate'
            >
              <FilterCountryDiv />

              {countryList.length ? (
                <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-5 px-2'>
                  {countryList.map((country) => (
                    <SetupCard
                      key={country.id}
                      title={country.country_name}
                      label={
                        <span className='flex items-center gap-2'>
                          <ReactCountryFlag
                            style={{ width: '1.5em', height: '1.42em' }}
                            countryCode={country.iso_code}
                            svg
                          />
                          {country.country_name}
                        </span>
                      }
                      deleteBtnTitle='Remove Country'
                      editBtnTitle='Update Country'
                      showDeleteModalHandler={
                        featureBasedPermissions.includes('DELETE')
                          ? () => {
                              setTargetedCountry(country);
                              setShowDeleteModal(true);
                            }
                          : undefined
                      }
                      showEditModalHandler={
                        featureBasedPermissions.includes('UPDATE')
                          ? () => {
                              setTargetedCountry(country);
                              setShowEditModal(true);
                            }
                          : undefined
                      }
                    >
                      <div className='border-t border-dashed border-legal-dark-blue pt-1'>
                        <SetupCardBodyInfo
                          label='ISO Code'
                          info={country.iso_code}
                        />

                        <SetupCardBodyInfo
                          label='ISD Code'
                          info={country.isd_code}
                        />
                      </div>
                    </SetupCard>
                  ))}
                </div>
              ) : (
                <NoTableDataFound message='No countries found!!' />
              )}
            </motion.div>
          </>
        ) : (
          <AcademiaLoading />
        )
      ) : isError ? (
        <AcademiaNotFound message='Failed to load country data!!' />
      ) : null}
    </section>
  );
};

export default ShowAllCountries;
